// extracted by mini-css-extract-plugin
module.exports = {"ckdqdpa":"ckdqdpa"};